module.exports = __webpack_public_path__ + "static/slide3-743x573-02d8f8e6e047bd262d37f21fa47d4264.gif";